import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { get80IACApplicationDetails, updateIacAction, updateimbStatus } from '../../dependencies/action';
import { fetchRejectionList } from '../../../../dependencies/services/getRejectList';
import GlobalDropDown from '../../../common/GlobalDropDown/index'
import TextareaField from '../../../common/TextareaField'
import FormValidator from '../../dependencies/FromValidator';
import ApprovedRejectDropDown from '../../../../dependencies/utils/json/approvedReject.json';
import { useDispatch } from 'react-redux';
import { updateSaveView80iac } from '../../view/dependencies/action';
const ActionModal = (props) => {

    const {
        data,
        buttonLabel,
        className
    } = props;
    const refreshApi80Iac = () => props.callApi80Iac();
    const [incompleteStatus, setIncompleteStatus] = useState([]);
    const [approvedRejectStatus, setApprovedRejectStatus] = useState('')
    const [other, setOther] = useState('');
    const [showInputFiled, setShowInputFiled] = useState(false);
    const [incompleteStatusTitle, setIncompleteStatusTitle] = useState([])
    const [error, setError] = useState({});
    const [hasInvalidSubmitOccurred, setHasInvalidSubmitOccurred] = useState(false);
    const [otherValue, setOtherValue] = useState('');
    const [otherError, setOtherError] = useState('')
    const [submitValue, setSubmitValue] = useState('')
    const dispatch = useDispatch();
    const [rejectImbNumber, setRejectImbNumber] = useState('')

    const sAppId = props.match.params.id;

    useEffect(() => {
        if(props.actionValue == 'DOCUMENT_VERIFIED') {
            dispatch(fetchRejectionList({
                enablerType: "STARTUP",
                startupRejectType: "REJECT_SECTION_56",
            }))
        }
        if(props.actionValue == 'INCOMPLETE') {
            dispatch(fetchRejectionList({
                enablerType: "STARTUP",
                startupRejectType: "INCOMPLETE_80_IAC",
            }))
        }
    }, [])

    if (props.getRejectList) {
        var outputSrtUpAppList = props.getRejectList.map(s => ({ text: s.reason, value: s.id }));
    }




    


    const onBlur = (e, name) => {
        validateInput();
    }

    //   const validateInput = () => {
    //     let otherData = {}
    //     if ( approvedRejectStatus === 'REJECT') {
    //         otherData = { other }
    //     }

    //       let imbNumberError = "";
    //       if (!submitValue || submitValue.length < 1 || submitValue.length > 3) {
    //           imbNumberError = "This field is required";
    //       }
        
   
    

    
    //      let rejectImbNumberError = '';
    // if (!rejectImbNumber || rejectImbNumber.trim().length < 1) {
    //     rejectImbNumberError = 'This field is required.';
    // } 
    //  let rejectOtherError = '';
    // if (!other || other.trim().length < 1) {
    //     rejectOtherError = 'This field is required.';
    // } 
    //     const errors = {
    //         other: rejectOtherError,
    //         rejectImbNumber: rejectImbNumberError,
    //         imbNumberError: imbNumberError
    //     };
    //     setError(errors);
    //     return  !rejectImbNumberError && !rejectOtherError || !imbNumberError;
    // };

     const validateInput = () => {
    let otherData = {}
    if (approvedRejectStatus === 'REJECT') {
        otherData = { other }
    }

    let imbNumberError = "";
    if (props.actionValue === "APPROVED") {
        if (!submitValue || submitValue.length < 1 || submitValue.length > 3) {
            imbNumberError = "This field is required.";
        }
    }
    let rejectImbNumberError = '';
    if (props.actionValue === "approvedReject") {
        if (!rejectImbNumber || rejectImbNumber.length < 1 || rejectImbNumber.length > 3) {
            rejectImbNumberError = 'This field is required.';
        }
    }

    let rejectOtherError = '';
    if (props.actionValue === "approvedReject") {
        if (!other || other.trim().length < 1) {
            rejectOtherError = 'This field is required.';
        }
    }

    const errors = {
        other: rejectOtherError,
        rejectImbNumber: rejectImbNumberError,
        imbNumberError: imbNumberError
    };

    setError(errors);

    return (
        !rejectImbNumberError && 
        !rejectOtherError && 
        !imbNumberError
    );
};
    const submitFormHandler = async (e) => {
        e.preventDefault();

        if (!validateInput()) {
            setHasInvalidSubmitOccurred(true)
            
        } else {
            let sendRes = {}
            let status = props.actionValue
            if (approvedRejectStatus) {
                status = approvedRejectStatus
                if (approvedRejectStatus === 'REJECT')
                    sendRes = {
                        rejectDescription: other
                    }
            } else if (incompleteStatus) {
                 if (props.actionValue === "INCOMPLETE") {
                    const arrayToObject = incompleteStatus.map((item) => { return { id: item } })
                    sendRes = {
                        incompleteReasons: arrayToObject,
                        incompleteDescription: other
                    }
                }
                if(props.actionValue === "approvedReject"){
                    sendRes = {
                        reason: other
                    }
                }

            }if (props.actionValue === "APPROVED" || props.actionValue === "approvedReject") {
                await props.updateIacAction({
                    id: props.id,
                    status: "ON_HOLD",
                    imbNumber: rejectImbNumber,
                    ...sendRes
                })
            } else {
                await props.updateIacAction({
                    id: props.id,
                    status: status,
                    ...sendRes
                })
            }
            await toggle();
            if (approvedRejectStatus === 'REJECT') {
                await refreshApi();
            } else {
                await refreshApi();
            }

        }
    }

    const setTextValue = (e) => {
        // console.log(e.target.value)
        setOtherValue(e.target.value)
    }

    const ActionIMBRecommend = async () => {
        if (!otherValue) {
            setOtherError('Please enter reason!')
            return false
        }
        setOtherError('')
        await props.updateIacAction({
            id: props.id,
            status: "ON_HOLD",
            reason: otherValue
        })
        await toggle();
        await refreshApi();


    }

    const handleInput = (e, name) => {
        let value = e.target.value;
        if (name === 'approvedRejectValue') {
            if (e.target.value === 'REJECT') {
                setShowInputFiled(true)
            } else {
                setShowInputFiled(false)
            }
            setApprovedRejectStatus(e.target.value)
        } else if (name === 'incompleteDropDownValue') {
            const val = [];
            const titles = [];
            let options = e.target.options;
            options = Array.from(options);
            let otherSelected = false;
            for (let i = 0, l = options.length; i < l; i++) {
                if (options[i].selected) {
                    val.push(options[i].value);
                    titles.push(options[i].title);
                    if (options[i].title.indexOf('Others- If any other') > -1 && otherSelected === false) {
                        otherSelected = true;
                    }
                }
            }
            setIncompleteStatusTitle(titles)
            setIncompleteStatus(val)
            if (otherSelected) {
                setShowInputFiled(true)
            } else {
                setShowInputFiled(false)
            }
        } else if (name === 'other') {
            setOther(e.target.value)
        }
        else if(name === 'rejectImbNumber'){
            setRejectImbNumber(e.target.value)
        }
    }
    const toggle = () => props.toggleActionModal();
    const refreshApi = () => props.callApi();


    // const actionPerform = async () => {
    //     const payload = {
    //         id: props?.data?.ScoreCard?.score?.id,
    //         formId: props?.sAppId,
    //         incorporationNumber: props?.data?.ScoreCard?.score?.incorporationNumber,
    //         ...Scorce
    //     }

    //     dispatch(updateSaveView80iac(payload))
    //     await props.updateIacAction({
    //         id: props.id,
    //         status: props.actionValue
    //     })
    //     await toggle();
    //     await refreshApi();
    //     if (props.actionValue == 'ARCHIVE') {
    //         props.history.push('/application/80iac');
    //     }

    // }
    const payload = {
        // id: data?.score?.id,
        formId: sAppId,
        // incorporationNumber: data?.score?.incorporationNumber,
        creditRatingScore: data?.score?.adminScore?.creditRatingScore,
        scalabilityScore: data?.score?.adminScore?.scalabilityScore,
        achievementsAwards: data?.score?.adminScore?.achievementsAwards,
        directEmployment: data?.score?.adminScore?.directEmployment,
        employmentTierAndCities: props?.data?.ScoreCard?.score?.adminScore?.employmentTierAndCities,
        femaleMaleRatio: data?.score?.adminScore?.femaleMaleRatio,
        fundingObtained: data?.score?.adminScore?.fundingObtained,
        intellectualProperty: data?.score?.adminScore?.intellectualProperty,
        profitability: data?.score?.adminScore?.profitability,
        researchDevelopmentExpense: data?.score?.adminScore?.researchDevelopmentExpense,
        revenueGeneration: data?.score?.adminScore?.revenueGeneration,
        stageOfProductService: data?.score?.adminScore?.stageOfProductService,
employeeNonMetroCities: data?.score?.adminScore?.employeeNonMetroCities,
employmentOfResearchPersonnel:data?.score?.adminScore?.employmentOfResearchPersonnel,
pwdFemaleEmploymentCount:data?.score?.adminScore?.pwdFemaleEmploymentCount

    }

    const actionPerform = async () => {

        const payload = props.actionValue === 'APPROVED' || props.actionType === 'approvedReject'
            ? {
                imbNumber: submitValue,
                id: props.id,
                status: props.actionValue,
            }
            : {
                id: props.id,
                status: props.actionValue,
            };

            await props.updateIacAction(payload);

        // await props.updateIacAction({
        //     id: props.id,
        //     status: props.actionValue,
        //     imbNumber: submitValue
        // })
        // .then((res) => {
        //     console.log("ress >>", res)
        //     if(res.status){
        //         dispatch(updateSaveView80iac(payload))
        //     }
        // }
    // );


        await toggle();
        await refreshApi();

        if (props.actionValue === 'ARCHIVE') {
            props.history.push('/application/80iac');
        }
    };

    return (
        <div>
            {/* <Button color="danger" onClick={toggle}>{buttonLabel}</Button> */}
            <Modal isOpen={props.modalValue} toggle={toggle} className={className}>
                <ModalHeader toggle={toggle}>{
                    ((props.actionValue === 'approvedReject') ? 'ON HOLD' : (props.actionValue === 'notRecommend') ? 'Reason For Not Recommending' : props.actionValue)
                }</ModalHeader>
                {/* <ModalBody>

                    {props.actionValue === 'INCOMPLETE'
                        ? (
                            <form className="filter-form" onSubmit={submitFormHandler}>

                                <GlobalDropDown
                                    required
                                    label='Reason'
                                    selectTagStyle="form-control dropdown-media"
                                    multiple
                                    onChange={handleInput}
                                    options={outputSrtUpAppList}
                                    name={'incompleteDropDownValue'}
                                    defaultOptionDisable={true}
                                    value={incompleteStatus}
                                    error={error.dropDownValidate}
                                    onBlur={onBlur}
                                    hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                                />
                                {showInputFiled &&
                                    <TextareaField

                                        required
                                        type="text"
                                        name="other"
                                        label="Other"
                                        value={other}
                                        onChange={handleInput}
                                        error={error.other}
                                        containerClass={"form-group"}
                                        onBlur={onBlur}
                                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                                    />
                                }
                                <div className="button-wrap">
                                    <button type='submit' className='bttn'>Submit</button>
                                </div>
                            </form>
                        ) : (props.actionValue === 'approvedReject'
                            ? (<form className="filter-form" onSubmit={submitFormHandler}>

                              <TextareaField
                               required
            label="IMB Number"
            name="rejectImbNumber"
            type="rejectImbNumber"
            value={rejectImbNumber}
            onChange={handleInput}
            onBlur={onBlur}
            containerClass="form-group"
            hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            minLength={1}
            maxLength={3}
            error={error.rejectImbNumber}
            placeholder ="Please enter a IMB number"
            />


                                    <TextareaField

                                        required
                                        type="text"
                                        name="other"
                                        label="Other"
                                        value={other}
                                        onChange={handleInput}
                                        error={error.other}
                                        containerClass={"form-group"}
                                        onBlur={onBlur}
                                        hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}

                                    />

                                
                                <div className="button-wrap">
                                    <button type='submit' className='bttn'>Submit</button>
                                </div>

                            </form>) : (props.actionValue === 'notRecommend'
                                ? (
                                    <>
                                        <div>
                                            <textarea className="form-control" name="textValue" onChange={(e) => setTextValue(e)} value={otherValue} placeholder="Input your message" />
                                            {
                                                otherError ? (<label className='text-danger'>{otherError}</label>) : ''
                                            }
                                            <br />

                                        </div>
                                        <Button style={{
                                            background: '#18AD00',
                                            border: 'none',
                                            padding: '5px  15px',
                                            margin: '0 41.5%',
                                        }} onClick={ActionIMBRecommend}>Submit</Button>
                                    </>
                                )
                                : 'Do you want to proceed?') : 
                            )

                    }
                </ModalBody> */}

                <ModalBody>
                    {props.actionValue === 'INCOMPLETE' ? (
                        <form className="filter-form" onSubmit={submitFormHandler}>
                            <GlobalDropDown
                                required
                                label='Reason'
                                selectTagStyle="form-control dropdown-media"
                                multiple
                                onChange={handleInput}
                                options={outputSrtUpAppList}
                                name={'incompleteDropDownValue'}
                                defaultOptionDisable={true}
                                value={incompleteStatus}
                                error={error.dropDownValidate}
                                onBlur={onBlur}
                                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                            />
                            {showInputFiled && (
                                <TextareaField
                                    required
                                    type="text"
                                    name="other"
                                    label="Other"
                                    value={other}
                                    onChange={handleInput}
                                    error={error.other}
                                    containerClass={"form-group"}
                                    onBlur={onBlur}
                                    hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                                />
                            )}
                            <div className="button-wrap">
                                <button type='submit' className='bttn'>Submit</button>
                            </div>
                        </form>
                    ) : props.actionValue === 'approvedReject' ? (
                        <form className="filter-form" onSubmit={submitFormHandler}>
                            {/* <GlobalDropDown
                                required
                                label='Status'
                                containerStyle="form-group "
                                selectTagStyle="form-control dropdown-media"
                                onChange={handleInput}
                                options={ApprovedRejectDropDown}
                                value={approvedRejectStatus}
                                name={'approvedRejectValue'}
                                error={error.dropDownValidate}
                                onBlur={onBlur}
                                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                            /> */}
                                {/* <TextareaField
                               required
                                    label="IMB Number"
                                    name="rejectImbNumber"
                                    type="rejectImbNumber"
                                    value={rejectImbNumber}
                                    onChange={handleInput}
                                    onBlur={onBlur}
                                    containerClass="form-group"
                                    hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                                    minLength={1}
                                    maxLength={3}
                                    error={error.rejectImbNumber}
                                    placeholder="Please enter IMB number"
                                /> */}
                                <label>Please provide IMB Number <span style={{ color: 'red' }}>*</span></label>
                                <input type='text' value={rejectImbNumber} maxLength={3} minLength={1} onChange={(e) => setRejectImbNumber(e.target.value.replace(/[^0-9]/g, ""))} />

                                {/* {error.rejectImbNumber ? <label className='text-danger'>{error.rejectImbNumber}</label> : ''} */}
                                {error.rejectImbNumber ? <div className='inline-error' style={{

                                    fontWeight: "400",
                                    fontSize: "12px"
                                }}>{error.rejectImbNumber}</div> : ''}

                            {/* {showInputFiled && ( */}
                                <TextareaField
                                    required
                                    type="text"
                                    name="other"
                                    label="Comment"
                                    value={other}
                                    onChange={handleInput}
                                    error={error.other}
                                    containerClass={"form-group"}
                                    onBlur={onBlur}
                                    hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
                                />
                            {/* )} */}
                            <div className="button-wrap">
                                <button type='submit' className='bttn'>Submit</button>
                            </div>
                        </form>
                    ) : props.actionValue === 'APPROVED' ? (
                        <form className="filter-form" onSubmit={submitFormHandler}>
                                    <label>Please provide IMB Number <span style={{ color: 'red' }}>*</span></label>
                                    <input type='text'  value={submitValue} maxLength={3} minLength={1}  onChange={(e) => setSubmitValue(e.target.value.replace(/[^0-9]/g,""))} />
                                    {/* {error.imbNumberError ? <label className='text-danger'>{error.imbNumberError}</label> : ''} */}
                                    {error.imbNumberError ? <label className='text-danger' style={{

                                        fontWeight: "400",
                                        fontSize: "12px"
                                    }}>{error.imbNumberError}</label> : ''}

                                    <br/>
                                    <br/>

                                    <div className="button-wrap">
                                       
                                        <Button  className='bttn' disabled={!submitValue} onClick={()=> {
                                            if(submitValue){
                                                actionPerform();
                                            }
                                        }} >Submit</Button>
                                    </div>
                                </form>
                    ) : props.actionValue === 'notRecommend' ? (
                        <>
                            <div>
                                <textarea className="form-control" name="textValue" onChange={(e) => setTextValue(e)} value={otherValue} placeholder="Input your message" />
                                            {/* {otherError ? (<label className='text-danger'>{otherError}</label>) : ''} */}
                                            {otherError ? (<label className='text-danger' style={{

                                                fontWeight: "400",
                                                fontSize: "12px"
                                            }}>{otherError}</label>) : ''}

                                <br />
                            </div>
                                        <Button style={{
                                            background: '#18AD00',
                                            border: 'none',
                                            padding: '5px  15px',
                                            margin: '0 41.5%',
                                        }} onClick={ActionIMBRecommend}>Submit</Button>
                        </>
                    ) : (
                        'Do you want to proceed?'
                    )}
                </ModalBody>
                    
                {props.actionValue !== 'INCOMPLETE' && props.actionValue !== 'approvedReject' && props.actionValue !== 'notRecommend' && props.actionValue !== 'APPROVED' ? 
                    (
                        <ModalFooter>
                            {props.actionValue !== 'INCOMPLETE'
                                ? <Button color="primary" onClick={actionPerform}>Ok</Button>
                                : ''}

                        </ModalFooter>
                    )
                    :
                    ''
                }
            </Modal>
        </div>
    );
}

const mapStateToProps = (state) => {

    return {
        getRejectList: state.getRejectListReducer.rejectionList
    }
}
export default connect(mapStateToProps, { updateIacAction, fetchRejectionList, updateimbStatus })(withRouter(ActionModal))
